// extracted by mini-css-extract-plugin
module.exports = {"gridWrapper":"newsList-module--gridWrapper--er2fe"};